import React, { useEffect, useState } from 'react';
import { Header, IconName } from 'react-frontier2';

interface Props{
	text?: string,
	iconName?: IconName,
	error: string,
	loading?: boolean
}

var ErrorHeader = (props: Props)=>{
	if(!props.error) return null;
	return <Header text={props.text || "Error"} subtext={props.error} iconName={props.iconName || 'face-frown-open'} />
}

export default ErrorHeader;